/**
 * Beyond enrollment enum messages based on Docebo course status
 * This replaces the Docebo status with the custom Beyond enrollment statuses.
 */
export enum EnrollmentMessage {
  ENROLL = 'Enroll',
  REVIEW = 'Review',
  CONTINUE = 'Continue',
  START = 'Start',
  WAITLIST = 'Waitlist',
  VIEW = 'View',
  VIEW_DETAILS = 'View Details',
  VIEW_STUDY_GUIDE = 'View Study Guide',
  VIEW_SESSIONS = 'View Sessions',
  REGISTRATION_CLOSED = 'Registration Closed',
}
